<template>
  <div>
    <profilesPage
      :loading="loading"
      :path="path"
      :title="title"
      :create-btn="createBtn"
      :select="select"
      :select-options="selectOptions"
      :fields="fields"
      :items="items"
      :name="name"
      :pageTotal="pageTotal"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @handleSearch="handleSearch"
      :currentPage="currentPage"
      :rows="rows"
      :sort="sort"
      :direct="direct"
      @orderHead="orderHead"
      @selectFilmType="selectFilmType"
    />
  </div>
</template>

<script>
import profilesPage from '../profilespage/profilesPage'
import { getScriptwriterApi } from '@/api/film-material-management/scriptwriter'

export default {
  components: {
    profilesPage,
  },
  data() {
    return {
      sort: 'id',
      direct: 'desc',
      loading: false,
      title: '編劇',
      name: 'Scriptwriter',
      createBtn: '開立新編劇記錄',
      select: '全部地區',
      path: '/dashboard/scriptwriter-info',
      selectOptions: ['全部地區', '香港', '非香港'],
      currentPage: 1,
      fields: [
        {
          key: 'id',
          label: 'Scriptwriter ID',
          sortKey: 'id',
        },
        {
          key: 'name_en',
          label: 'Scriptwriter Name',
          sortKey: 'scriptwriter_name_en',
        },
        {
          key: 'name_cn',
          label: '編劇名稱',
          sortKey: 'scriptwriter_name_zh_hk',
        },
        {
          key: 'action',
          label: '',
        },
      ],
      items: [],
      pageTotal: 10,
      rows: 20,
      search: '',
      location: '',
      isOld: 0,
    }
  },
  methods: {
    selectFilmType(val) {
      this.isOld = val
      this.getScriptwriterList()
    },
    orderHead(key, direct) {
      this.sort = key
      this.direct = direct
      this.getScriptwriterList()
    },
    handleSizeChange(val) {
      this.rows = val
      this.getScriptwriterList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getScriptwriterList()
    },
    handleSearch(val) {
      this.currentPage = 1
      this.rows = val.rows
      this.location = val.selectArea
      this.search = val.search
      this.sort = val.sort
      this.direct = val.direct
      this.getScriptwriterList()
    },
    getScriptwriterList() {
      this.loading = true
      const data = {
        page: this.currentPage,
        count: this.rows,
        area: this.location,
        search: this.search,
        sort: this.sort,
        direct: this.direct,
        arch: this.isOld,
      }
      getScriptwriterApi(data)
        .then((res) => {
          this.items = res.data
          this.pageTotal = res.total
          const arr = []
          this.items.forEach((el) => {
            const obj = new Object()
            obj.id = el.id
            obj.name_cn = el.scriptwriter_name_zh_hk
            obj.name_en = el.scriptwriter_name_en
            obj.name_other = el.scriptwriter_name_other
            obj.area = el.area
            arr.push(obj)
          })
          this.items = arr
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  mounted() {
    this.getScriptwriterList()
  },
}
</script>

<style lang="scss" scoped></style>
